import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {L} from "../lt-ng/landcare-toolkit";
import {IPinData} from "../services/PinApi";
import Item = L.tree.Item;
import {IPortalServices, IRequestError} from "../lt-ng/portal-services";
import {IPointQueryResult, processOEPointQueryResult} from "../lt-ng/portal-services-utils";
import {_F} from "../utility/func";
import isDefined = _F.isDefined;
import {IPointReport} from "../services/ISharedFeatureState";

interface IExtraPointQueryAttributes {
    pinData: IPinData;
    layers: Item[];
}

const NO_ATTRIBUTES = [];

class ExtraAttributesController implements ng.IComponentController, IExtraPointQueryAttributes {
    public pinData: IPinData;
    public layers: Item[];

    constructor(protected mapService: IMapService, protected portalServices: IPortalServices, protected $q: ng.IQService) {

    }

    isDefined = isDefined;

    inProgress = false;

    _attributesRequest : ng.IPromise<IPointReport | IRequestError>;
    _cancelRequest: () => void;
    _attributes: IPointQueryResult[];
    get attributes(): IPointQueryResult[] {
        if (!this._attributesRequest && this.layers && this.layers.length && this.pinData) {
            this.inProgress = true;
            const layers = this.layers;
            const coordinate = [this.pinData.x, this.pinData.y];
            const layerNames = this.layers.map(l => l.layerService && l.layerService.layerName).filter(ln => !!ln);
            const cancel = this.$q.defer();
            this._cancelRequest = () => {
                cancel.resolve();
                this._attributes = null;
                this._attributesRequest = null;
                this._cancelRequest = null;
                this.inProgress = false;
            };

            /*const requests = layerNames.map(ln => {
                return this.portalServices.dataPointQuery(coordinate, ln, { cache: true }, false);
            })

            this._attributesRequest = this.$q.all(requests).then(results => {
                const validResponses: IPointReport[] =  <any> results.filter(r => 'response' in r);
                if (validResponses.length) {
                    return {
                        response: {
                            ...validResponses[0].response,
                            layers: validResponses.map(resp => resp.response.layers).flat(1)
                        }
                    }
                } else {
                    return {
                        error: 'no responses'
                    }
                }
            })*/

            this._attributesRequest = this.portalServices.dataPointQuery(coordinate, layerNames, { cache: true }, false);
            this._attributesRequest.then(resp => {
                this.inProgress = false;
                if ('response' in resp) {
                    // success
                    this._attributes = processOEPointQueryResult(resp, layers, this.mapService.treeData);
                }
            })

        }

        return this._attributes || NO_ATTRIBUTES;
    }

    $onChanges(onChangesObj: ng.IOnChangesObject) {
        if (onChangesObj.pinData || onChangesObj.layers) {
            this._attributes = null;
            if (this._cancelRequest) this._cancelRequest();
        }
    }
}

export class ExtraPointQueryAttributes implements ng.IComponentOptions {
    controller = ['landcareMapService', 'portalServices', '$q', ExtraAttributesController];

    bindings = {
        pinData: '<',
        layers: '<'
    };

    templateUrl = '/Partial/component/ExtraPointQueryAttributes'
}
